<template>
  <dx-link
    :class="['dx-navbar-aside-item', { 'dx-navbar-aside-item--active': isActive }]"
    :style="[textAlign, border]"
    :onclick="handleClick"
    :withIcon="this.external"
  >
    <dx-text>
      {{ description }}
    </dx-text>
  </dx-link>
</template>
<script>
export default {
  name: 'dx-navbar-aside-item',
  props: {
    description: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: false,
    },
    redirectPage: {
      type: String,
      required: false,
    },
    external: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'center',
    },
    borderColor: {
      type: String,
      default: 'none',
    },
  },
  computed: {
    isActive() {
      return this.$route.name?.includes(this.redirectPage);
    },
    textAlign() {
      return `text-align: ${this.align}`;
    },
    border() {
      return this.borderColor ? `border-left: 12px solid var(--dx-color--${this.borderColor})` : '';
    },
  },
  methods: {
    handleClick() {
      if (this.action) this.action();
      if (this.redirectPage) this.$router.push({ name: this.redirectPage });
    },
  },
};
</script>
<style scoped lang="scss">
.dx-navbar-aside-item {
  display: block;
  padding: calc(var(--dx-space-size--xs) - 2px);
  color: var(--dx-color--grey-dark-light);
  text-decoration: none;
  margin: 4px calc(var(--dx-space-size--xs) / 2);
  border-radius: calc(var(--dx-space-size--xs) / 2);

  &:hover,
  &--active {
    color: var(--dx-color--blue);
    background-color: var(--dx-color--blue-light);
    font-weight: 500;
  }
}
</style>
